function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedDoubleBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8v9c-.63.84-1 1.87-1 3v9h2v-3h26v3h2v-9c0-1.13-.37-2.16-1-3V8c0-2.76-2.24-5-5-5H7C4.24 3 2 5.24 2 8zm5-3C5.34 5 4 6.34 4 8v7.42c.33-.14.68-.25 1.04-.32.12-1.4.49-2.5.93-3.32.26-.49.56-.88.84-1.17.14-.14.29-.27.46-.38.13-.08.4-.23.74-.23h6c.34 0 .61.15.74.23.16.1.31.23.46.38.27.27.55.65.81 1.11.26-.46.54-.84.81-1.11.14-.14.29-.27.46-.38.13-.08.4-.23.74-.23h6c.34 0 .61.15.74.23.16.1.32.23.46.38.28.29.57.68.84 1.17.44.81.82 1.92.93 3.32.36.07.71.18 1.04.32V8c0-1.66-1.34-3-3-3H7zm17.94 10c-.12-1-.39-1.75-.67-2.27-.19-.35-.37-.58-.5-.71l-.02-.02h-5.51l-.02.02c-.13.13-.31.36-.5.71-.28.52-.56 1.28-.67 2.27h7.89zm-10 0c-.12-1-.39-1.75-.67-2.27-.19-.35-.37-.58-.5-.71l-.02-.02H8.24l-.02.02c-.13.13-.31.36-.5.71-.28.52-.56 1.28-.67 2.27h7.89zM3 20c0-1.66 1.34-3 3-3h20c1.66 0 3 1.34 3 3v4H3v-4z",
    fill: props.color
  }));
}

export default SvgIconBedDoubleBedFilled;